<script setup>
import {
  formatSnow,
  getAlertColorForeground,
  isMetric,
  safeRound,
} from '@@/utils/CommonUtils';
import { useMetaStore } from '@@/stores/Meta';
import { useUserStore } from '@@/stores/User';

defineProps({
  containerClass: {
    type: String,
    default: null,
  },
  isCompare: {
    type: Boolean,
    default: true,
  },
  isSkeleton: {
    type: Boolean,
    default: false,
  },
  location: {
    type: Object,
    default: null,
  },
  mobileDateLongWrap: {
    type: Boolean,
    default: false,
  },
  range: {
    type: Object,
    default: null,
  },
});

const metaStore = useMetaStore();
const userStore = useUserStore();

const units = computed(() => userStore.preferences.units);

const formatPrecipSnow = (precipSnow) => {
  if (isMetric(units.value)) {
    return safeRound(precipSnow);
  }

  return formatSnow(safeRound(precipSnow), units.value, true);
};

const getPrecipSnowTextStyle = (snowSummary) => {
  const powderAlert = metaStore.getPowderAlert(snowSummary.alerts);
  const color = getAlertColorForeground(powderAlert);
  return { color };
};
</script>

<template>
  <div :class="containerClass">
    <div class="tw-flex">
      <SnowChartHeader
        :amount-cumulative="formatPrecipSnow(location.forecast_snow_summary[0].precip_snow)"
        :amount-cumulative-text-style="getPrecipSnowTextStyle(location.forecast_snow_summary[0])"
        class="tw-w-1/2"
        :is-skeleton="isSkeleton"
        :label="location.forecast_snow_summary[0].display_at_local_label"
      />
      <SnowChartHeader
        :amount-cumulative="formatPrecipSnow(location.forecast_snow_summary[1].precip_snow)"
        :amount-cumulative-text-style="getPrecipSnowTextStyle(location.forecast_snow_summary[1])"
        class="tw-w-1/2"
        :is-skeleton="isSkeleton"
        :label="location.forecast_snow_summary[1].display_at_local_label"
        :show-left-border="false"
      />
    </div>
    <SnowForecastChart
      :can-show-chart-header="false"
      :end-day="9"
      :is-compare="isCompare"
      :is-skeleton="isSkeleton"
      :location="location"
      :mobile-date-long-wrap="mobileDateLongWrap"
      :range="range"
      :start-day="0"
    />
  </div>
</template>
